(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wubs-manual-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wubs-manual-video')) {
    customElements.define('wubs-manual-video', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('[data-manual-video-dialog]');
        this.frame = this.querySelector('[data-manual-video-frame]');
        this.trigger = this.querySelector('[data-manual-video-trigger]');
        if (!this.dialog || !this.frame || !this.trigger) return;

        this.trigger.addEventListener('click', event => {
          if (!this.dialog.showModal || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const id = this.dataset.videoId;
          if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
          event.preventDefault();
          if (this.dialog.open) return;
          this.dialog.showModal();
          this.previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          const iframe = document.createElement('iframe');
          iframe.title = `${this.dialog.getAttribute('aria-label')}: ${this.trigger.querySelector('.wubs-manual-video__product').textContent}`;
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
          iframe.allowFullscreen = true;
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0&playsinline=1`;
          this.frame.replaceChildren(iframe);
        });

        this.dialog.addEventListener('close', () => {
          this.frame.replaceChildren();
          document.documentElement.style.overflow = this.previousOverflow ?? '';
        });

        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        });
      }

      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
